import { initRecaptcha } from "../gRecaptcha";
import MicroModal from "./micromodal";
import { Core } from "Components/core";

let firstModalOpen = true;

const options = {
  onShow: function onShow(modal) {
    Modal.getInstance(modal)._onShow();
  },
  onClose: (modal, ...args) => {
    // console.log("onClose arguments", modal, ...args);
    Modal.getInstance(modal)._onClose();
  },
  openTrigger: "data-modal-open",
  closeTrigger: "data-modal-close",
  openClass: "modal_visible",
  disableScroll: true,
  disableFocus: true,
  awaitOpenAnimation: true,
  awaitCloseAnimation: false,
  debugMode: false,
};

export class Modal extends Core {
  constructor(domElem) {
    super(domElem, Modal.className);
    this._isAttachedToScope = false;

    this.showModalOn();
  }

  showModalOn() {
    const onEvent = this.domElem.dataset.showModalOn;
    if (onEvent) {
      const bindSession = this.domElem.dataset.showModalBindSession;
      this.isModalOpened = bindSession
        ? !!window.sessionStorage.getItem(bindSession)
        : false;

      document.addEventListener("mouseleave", (event) => {
        if (event.clientY <= 0 && !this.isModalOpened) {
          MicroModal.show(this.domElem.id);
          this.isModalOpened = true;
          if (bindSession) {
            window.sessionStorage.setItem(bindSession, true);
          }
        }
      });
    }
  }

  /**
   * Set content
   * @param {Object} data
   */
  setContent(data) {
    var title = (data || {}).title,
      content = (data || {}).content;
    const status = data?.status ?? "general"; // 'success' | 'error' | 'warning' | 'general'

    title !== undefined && (this._getTitleElem().innerHTML = title);
    content !== undefined && (this._getContentElem().innerHTML = content);

    if (status) {
      this.setMod("status", status);
    }

    return this;
  }

  show() {
    MicroModal.show(
      this.domElem.id,
      Object.assign({}, options, {
        onShow: this._onShow.bind(this),
        onClose: this._onClose.bind(this),
      })
    );
    return this;
  }

  close() {
    MicroModal.close(this.domElem.id);
    return this;
  }

  _getTitleElem() {
    return this._title || (this._title = this.getElemNode("title"));
  }

  _getContentElem() {
    return this._content || (this._content = this.getElemNode("content"));
  }

  _getIconElem() {
    return this._icon || (this._icon = this.getElemNode("icon"));
  }

  _onShow() {
    if (!this._isAttachedToScope) {
      document.querySelector("body").append(this.domElem);
      this._isAttachedToScope = true;
    }

    if (firstModalOpen) {
      // console.log(
      //   "initRecaptchaOnFirstModalOpen(true)",
      //   initRecaptchaOnFirstModalOpen(true)
      // );
      firstModalOpen = false;
    }

    this._emit("open");
  }

  _onClose() {
    this._emit("close");
  }

  static className = "modal";
  static instances = {};

  static init() {
    document.querySelectorAll(`.${Modal.className}`).forEach(function (el) {
      return new Modal(el);
    });
    MicroModal.init(options);
  }
}

const initRecaptchaOnFirstModalOpen = (firstOpen = false) =>
  firstOpen &&
  document.body?.classList.contains("with--recaptcha") &&
  initRecaptcha();
